import { Component, OnInit } from '@angular/core';
import {ContentControllerService} from "../content-controller.service";

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {

    partnersContent: any;

    constructor(private contentControllerService: ContentControllerService) { }

    ngOnInit() {
        // this.contentControllerService.getPage('partners').then(response =>{
        //     this.partnersContent = response['items'][0];
        // });
    }
}
